import { motion } from 'framer-motion';
import { FaPlay } from 'react-icons/fa';

const StartGameOverlay = ({ onStart, gameName }) => {
  return (
    <motion.div 
      className="absolute inset-0 bg-black flex items-center justify-center"
      initial={false}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
    >
      <motion.button
        className="px-8 py-4 bg-white/10 hover:bg-white/20 rounded-xl flex items-center gap-3 group"
        whileHover={{ scale: 1.05 }}
        whileTap={{ scale: 0.95 }}
        onClick={onStart}
      >
        <FaPlay className="w-6 h-6 text-white group-hover:text-green-400 transition-colors" />
        <span className="text-2xl font-['VT323'] text-white group-hover:text-green-400 transition-colors">
          Start {gameName}
        </span>
      </motion.button>
    </motion.div>
  );
};

export default StartGameOverlay; 